export const outdoorData = [

    {
        id: 1,
        name: 'Powe Outdoor 3-piece Bar set ',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/80524460/resize-h310-w310%5Ecompr-r85/1196/119627148/Powe+Outdoor+3-Piece+Bar+Set.jpg'
    },
    {
        id: 2,
        name: 'Hull Bar Serving Cart',
        price: '$380',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/98071000/resize-h310-w310%5Ecompr-r85/6819/68199721/Hull+Bar+Serving+Cart.jpg'
    },
    {
        id: 3,
        name: 'Royalston 5 piece Bar set ',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/40385924/resize-h310-w310%5Ecompr-r85/5373/53730081/Royalston+Outdoor+5+Piece+Bar+Set.jpg'
    },
    {
        id: 4,
        name: 'Parik Cast 3-piece by canora grey',
        price: '$299.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/58103401/resize-h310-w310%5Ecompr-r85/7355/73554671/Parikh+Cast+Aluminum+3-Piece+Bar+Set.jpg'
    },
    {
        id: 5,
        name: 'Bushnell bar set by isle home',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/19279544/resize-h310-w310%5Ecompr-r85/6024/60249356/Bushnell+Bar+Set.jpg'
    },
    {
        id: 6,
        name: 'kragen BAR stool ',
        price: '$400',
        imageUrl: 'https://images.unsplash.com/photo-1560448204-444f743ef6e7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=60'
    },
    {
        id: 7,
        name: 'Moralez 30" bar stool',
        price: '$619.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/90660254/resize-h310-w310%5Ecompr-r85/9031/90316673/Audrick+Outdoor+Acacia+Wood+and+Wicker+30.7%2522+Patio+Bar+Stool+%2528Set+of+2%2529.jpg'
    },
    {
        id: 8,
        name: 'Patio Bar stool',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/07782777/resize-h310-w310%5Ecompr-r85/3241/32417980/Lansdale+30%2522+Patio+Bar+Stool+%2528Set+of+4%2529.jpg'
    },
    {
        id: 9,
        name: 'Tegan 40" patio bar stool',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/22162633/resize-h310-w310%5Ecompr-r85/6811/68115636/Tegan+30%2522+Patio+Bar+Stool+%2528Set+of+2%2529.jpg'
    },
    {
        id: 10,
        name: 'Shallon bar stool by red barrel studio',
        price: '$200',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/52884680/resize-h310-w310%5Ecompr-r85/1175/117517641/Shallon+28%2522+Patio+Bar+Stool.jpg'
    },
    {
        id: 11,
        name: 'Microfibre flaced arm sofa by andover mills',
        price: '$600',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/84980788/resize-h310-w310%5Ecompr-r85/8348/83482383/Erinn+67%2522+Flared+Arms+Loveseat.jpg'
    },
    {
        id: 12,
        name: 'cushion (set of 4) by isles home',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/03837585/resize-h310-w310%5Ecompr-r85/6802/68027683/Safira+30%2522+Patio+Bar+Stool+with+Cushion+%2528Set+of+4%2529.jpg'
    },
    {
        id: 13,
        name: 'Hudbarston square arm sofa by three posts',
        price: '$190',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/63204849/resize-h310-w310%5Ecompr-r85/6881/68815316/Briella+24%2522+Patio+Bar+Stool+with+Cushion+%2528Set+of+2%2529.jpg'
    },
    {
        id: 14,
        name: 'Nakagawa Wicker patio bar stool',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/06533459/resize-h310-w310%5Ecompr-r85/9031/90312218/Nakagawa+Wicker+28.75%2522+Patio+Bar+Stool+%2528Set+of+4%2529.jpg'
    },
    {
        id: 15,
        name: 'Ibiza loveseat by Zipcode deesign',
        price: '$350',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/06086196/resize-h310-w310%5Ecompr-r85/2552/25527758/Abbottsmoor+Patio+Bar+Stool+%2528Set+of+2%2529.jpg'
    },
    {
        id: 16,
        name: 'Edjar Reclining Arm sofa by Andover MIlls',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/08643375/resize-h310-w310%5Ecompr-r85/9072/90720518/Breslin+30%2522+Patio+Bar+Stool.jpg'
    },
    {
        id: 17,
        name: 'Garrido cushion by gracia oaks',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/08903671/resize-h310-w310%5Ecompr-r85/5518/55184135/Garrido+30%2522+Patio+Bar+Stool+with+Cushion+%2528Set+of+4%2529.jpg'
    },
    {
        id: 18,
        name: 'Preslin stool by fined design',
        price: '$299',
        imageUrl: 'https://images.unsplash.com/photo-1585550135883-ed03cd38c2de?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=60'
    }
];